import { useCitiesContext } from '@spotahome/ui-library';
import CityList from '@spotahome/ui-library/src/tenant/components/CityList';
import { SEO_LINK_CITIES_KEYS } from '@spotahome/ui-library/src/tenant/components/utils/seoConstants';

import './CityListContainer.scss';

const CityListContainer = () => {
  const { cities } = useCitiesContext();

  const listCities = cities
    .filter(city => SEO_LINK_CITIES_KEYS.includes(city.id))
    .sort((a, b) => a.cityName.localeCompare(b.cityName));

  return (
    <section className="city-list-container">
      <CityList
        cities={listCities}
        collapsible={false}
        titleKey={'top.cities.explore.title'}
      />
    </section>
  );
};

export default CityListContainer;
